const tones = {
  emerald: "bg-emerald-100 text-emerald-700 dark:bg-emerald-200 dark:text-emerald-900",
  blue:    "bg-blue-100 text-blue-700 dark:bg-blue-200 dark:text-blue-900",
  amber:   "bg-amber-100 text-amber-700 dark:bg-amber-200 dark:text-amber-900",
  rose:    "bg-rose-100 text-rose-700 dark:bg-rose-200 dark:text-rose-900",
};

export default function RangePill({ label, count, hint, tone }) {
  return (
    <div className="flex items-center justify-between rounded-xl border border-gray-200 p-4 text-sm dark:border-white/10">
      <div>
        <div className="font-semibold dark:text-white">{label}</div>
        <div className="text-xs text-gray-500">{hint}</div>
      </div>
      <span className={`rounded-full px-2 py-1 text-xs font-semibold ${tones[tone]}`}>
        {count}
      </span>
    </div>
  );
}
